// extracted by mini-css-extract-plugin
export default {"outer":"innerOuterContainer_outer__fMnBz","inner":"innerOuterContainer_inner__at4im"};